import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useCallback } from "react";
import { getWebinarStartDateAndTime, ScheduleResult } from "../util/webinars";

interface RenderOption {
  option: ScheduleResult;
  returnOnlyText?: boolean;
  isOptionSelected?: boolean;
}

const WebinarOptionsDropdown = ({
  options,
  onChange,
  value,
  selectedIndex,
}: {
  selectedIndex: number;
  value: ScheduleResult;
  options: ScheduleResult[];
  onChange: (index: number) => void;
}) => {
  const renderOption = useCallback(
    ({ option, returnOnlyText, isOptionSelected }: RenderOption) => {
      const [ProductDate, ProductTime] = getWebinarStartDateAndTime(
        option.StartDateString,
        option.EndDateString,
        option.TimeZone
      );

      if (returnOnlyText) {
        return `${ProductDate}, ${ProductTime}`;
      }

      if (isOptionSelected) {
        return (
          <div className="tw-bg-tr/75 tw-text-white tw-font-medium tw-px-6 tw-py-3 tw-cursor-pointer tw-rounded-md tw-flex tw-items-center">
            <span>
              {ProductDate}, {ProductTime}
            </span>
            <CheckCircleIcon className="tw-w-6 tw-h-6 tw-ml-3 tw-text-white" />
          </div>
        );
      }

      return (
        <div className="tw-text-tr-black tw-px-6 tw-py-3 tw-cursor-pointer tw-font-medium">
          {ProductDate}, {ProductTime}
        </div>
      );
    },
    []
  );

  return (
    <Menu>
      <Menu.Button
        className={
          "tw-w-full md:tw-w-auto tw-bg-[#F0F0F1] tw-px-6 tw-py-3 tw-text-tr-black tw-text-lg md:tw-text-xl tw-flex tw-items-center tw-justify-between tw-rounded-md"
        }
      >
        <span>{renderOption({ option: value, returnOnlyText: true })}</span>
        <ChevronDownIcon className="tw-w-4 tw-h-4 tw-ml-2" />
      </Menu.Button>

      <Menu.Items className="tw-origin-center md:tw-origin-top-left tw-absolute tw-left-0 tw-top-[50px] md:tw-top-auto md:tw-bottom-full tw-bg-[#F0F0F1] tw-shadow-xl tw-rounded-md tw-w-full md:tw-w-80">
        {options &&
          options.length > 0 &&
          options.map((option: ScheduleResult, index: number) => (
            <Menu.Item key={index} onClick={() => onChange(index)}>
              {renderOption({
                option,
                isOptionSelected: index === selectedIndex,
              })}
            </Menu.Item>
          ))}
      </Menu.Items>
    </Menu>
  );
};

export default WebinarOptionsDropdown;
